import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-azure', 'BrandAzure', [["path",{"d":"M6 7.5l-4 9.5h4l6 -15l-6 5.5"}],["path",{"d":"M22 20l-7 -15l-3 7l4 5l-8 3l14 0"}]]);